import { idtype } from "querypieces";

export default `
...on pageBuilder_parterSiteMap_BlockType {
	${idtype}
	heading
	richText
}
`